import axios from "../utils/axios";

/**
 * Get Customer Profile
 * @returns {Promise} Profile data
 */
export const getProfile = async () => {
    try {
        const { data } = await axios.get('/me/profile');
        return data;
    } catch (error) {
        console.error("🚀 ~ getProfile ~ error:", error);
        throw error;
    }
};

/**
 * Update Customer Profile
 * @param {Object} profileData - Profile data to update
 * @returns {Promise} Updated profile data
 */
export const updateProfile = async (profileData) => {
    try {
        const { data } = await axios.put('/me/profile', profileData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateProfile ~ error:", error);
        throw error;
    }
};
